import { useState, type ReactNode } from "react";
import { useNavigate } from "react-router";

import { Icon } from "./Icon.tsx";
import { Modal } from "./Modal.tsx";

/**
 * El boton "+" de la barra inferior, que ahora pregunta QUE se va a registrar.
 *
 * Lo pidio el propietario: "al darle clic al boton + de enmedio deberia que
 * salieran dos minicards para uno elegir si quiere nota o si quiere entrada de
 * trading".
 *
 * Y resuelve algo real, no solo dinamismo. Antes el "+" llevaba siempre al alta
 * de una operacion, asi que escribir una nota -que es la mitad de lo que se
 * apunta en una bitacora, y por eso las notas son un agregado propio (ADR
 * 0004)- habia que buscarlo en la caja de la bitacora. El destino mas grande de
 * la pantalla ofrecia una sola de las dos cosas que se hacen aqui.
 *
 * La nota NO se abre desde este componente: se delega a quien lo monte, porque
 * el modal de notas vive en la Bitacora con su lista y su cache, y duplicarlo
 * aqui serian dos sitios donde arreglar el mismo fallo.
 */
export function QuickAdd(props: { onNote: () => void }): ReactNode {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <>
      <button
        type="button"
        className="bn-fab"
        onClick={() => setOpen(true)}
        aria-label="Registrar algo nuevo"
        aria-haspopup="dialog"
      >
        <Icon name="plus" />
      </button>

      {open && (
        <Modal
          narrow
          title="Que vas a registrar"
          onClose={() => setOpen(false)}
          footer={
            <button type="button" className="btn ghost" onClick={() => setOpen(false)}>
              Cancelar
            </button>
          }
        >
          <div className="qa-grid">
            <button
              type="button"
              className="qa-card"
              onClick={() => {
                setOpen(false);
                navigate("/trades/new");
              }}
            >
              <span className="qa-ic trade">
                <Icon name="trend" />
              </span>
              <b>Operacion</b>
              <small>
                Simbolo, direccion, pips de riesgo y objetivo, y la captura. Lo demas se
                completa despues.
              </small>
            </button>

            <button
              type="button"
              className="qa-card"
              onClick={() => {
                setOpen(false);
                props.onNote();
              }}
            >
              <span className="qa-ic note">
                <Icon name="msg" />
              </span>
              <b>Nota</b>
              <small>
                La regla que te acabas de poner, lo que viste y no operaste, el aviso a ti
                mismo de manana.
              </small>
            </button>
          </div>
        </Modal>
      )}
    </>
  );
}
